import { useEffect } from "react";
import {
    BrowserRouter,
    Routes,
    Route,
    Navigate,
} from "react-router-dom";
import { LoginPage } from "@/pages/LoginPage";
import { AuditLogPage } from "@/pages/AuditLogPage";
import { ProtectedRoute, PublicOnlyRoute } from "@/routes/guards";
import { useSessionStore } from "@/store/session";
import { LoadingState } from "@/components/common/loading-state";

import "./index.css";

export const App = () => {
    const initialize = useSessionStore((state) => state.initialize);
    const status = useSessionStore((state) => state.status);

    useEffect(() => {
        initialize().catch(() => null);
    }, [initialize]);

    if (status === "checking") {
        return <LoadingState label="Preparing audit console…" className="min-h-screen" />;
    }

    return (
        <BrowserRouter>
            <Routes>
                <Route element={<PublicOnlyRoute />}>
                    <Route index element={<Navigate to="/login" replace />} />
                    <Route path="/login" element={<LoginPage />} />
                </Route>
                <Route element={<ProtectedRoute />}>
                    <Route path="/logs" element={<AuditLogPage />} />
                </Route>
                <Route
                    path="*"
                    element={
                        <Navigate
                            to={status === "authenticated" ? "/logs" : "/login"}
                            replace
                        />
                    }
                />
            </Routes>
        </BrowserRouter>
    );
};

